import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import './styles.scss';

const Pill = ({ itemKey, text, tooltipText }) => {
  return (
    <div className="pill">
      <div id={`${itemKey}`}>
        <span
          id={`${itemKey}`}
          style={{ maxWidth: '180px' }}
          className={`status badge badge-pill badge-outline-secondary`}
        >
          <div className="ellipsis">
            <div style={{ fontSize: '12px' }}>{text}</div>
          </div>
        </span>
      </div>
      {tooltipText && (
        <UncontrolledTooltip placement="top" target={`#${itemKey}`}>
          {tooltipText}
        </UncontrolledTooltip>
      )}
    </div>
  );
};

export default Pill;
